@if (isLoading) {
<div class="ui active inverted dimmer">
  <div class="ui large loader"></div>
</div>
}

<div [hidden]="showNoteForm">
  <header>
    <div id="title">
      <h2>{{ "notes" | transloco }}</h2>
      <div id="notes-assignee">
        @if (assignee) {
        {{ "notes-for" | transloco }}
        <strong>{{ assignee.firstName }} {{ assignee.lastName }}</strong>
        }
      </div>
    </div>

    <div id="actions">
      <div (click)="newNote()" class="ui primary background button">
        {{ "new-note" | transloco }}
      </div>
    </div>
  </header>

  <div id="body">
    @if (taxYear) {
    <div id="sidebar">
      <app-search-dropdown
        label="{{ yearLabel }}"
        [formGroup]="searchForm"
        [formCtrl]="taxYear"
        [listOptions]="taxYearOptions"
      ></app-search-dropdown>
      @if (notes?.length > 0) {
      <div id="list" class="hidden-scrollbar">
        @if (hasAssigneeNotes()) {
        <div id="assignee-notes">
          <h4>{{ taxReturnAlias }}</h4>
          <div class="ui list">
            @for (_note of notes; track _note) {
            <div
              [hidden]="!_note.assigneeId"
              class="item"
              [ngClass]="{ active: note?.id === _note.id }"
              (click)="selectNote(_note)"
            >
              {{ _note.title }}
            </div>
            }
          </div>
        </div>
        } @if (hasPopulatioNotes()) {
        <div id="population-notes">
          <h4>{{ "population" | transloco }}</h4>
          <div class="ui list">
            @for (_note of notes; track _note) {
            <div
              [hidden]="!_note.populationId"
              class="item"
              [ngClass]="{ active: note?.id === _note.id }"
              (click)="selectNote(_note)"
            >
              {{ _note.title }}
            </div>
            }
          </div>
        </div>
        }
      </div>
      } @if (notes?.length === 0) {
      <div class="no-results">{{ "no-notes-found" | transloco }}</div>
      }
    </div>
    }

    <div id="content">
      @if (note && note.id) {
      <div class="header">
        <h3>{{ note?.title }}</h3>
        <div id="years">{{ note?.startYear }} to {{ note?.endYear }}</div>
        @for (subcategory of note?.subcategories; track subcategory) {
        <div class="ui label">
          @if (subcategory && subcategory.name) {
          <span>{{ subcategory.name }}</span>
          }
        </div>
        }
      </div>
      <div class="body">
        <div id="note-content">
          @if (note.parts) {
          <app-comment
            [comment]="note.parts"
            [documents]="note.parts.documents"
          ></app-comment>
          }
        </div>
        @if (note?.assigneeId || (note?.populationId && population)) {
        <div (click)="editNote(note)" id="edit-note-btn">
          {{ "edit-note" | transloco }}
        </div>
        } @if (note?.assigneeId || (note?.populationId && population)) {
        <div (click)="deleteNote(note)" id="delete-note-btn">
          {{ "delete-note" | transloco }}
        </div>
        }
      </div>
      <div class="footer">
        <div>
          {{ "edited" | transloco }} {{ note?.updatedAtString }} by
          {{ note?.updatedBy }}
        </div>
        <div>
          {{ "created" | transloco }} {{ note?.createdAtString }} by
          {{ note?.createdBy }}
        </div>
      </div>
      }
    </div>
  </div>
</div>

@if (note && showNoteForm) {
<div [hidden]="note.status !== 0" id="note-form">
  <h2 *transloco="let t">
    {{ note?.id ? t("edit") : t("create") }} {{ "note" | transloco }}
  </h2>
  <form (submit)="saveNote()" class="ui fluid equal width grid">
    <div class="column">
      <label>{{ "note-title" | transloco }}</label>
      <input type="text" [(ngModel)]="note.title" name="title" />
    </div>
    <div class="row">
      <div class="column">
        <label>{{ "first-year-this-note-applies" | transloco }}</label>
        <input type="number" [(ngModel)]="note.startYear" name="startYear" />
      </div>
      <div class="column">
        <label>{{ "final-year-this-note-applies" | transloco }}</label>
        <input type="number" [(ngModel)]="note.endYear" name="endYear" />
      </div>
    </div>
    @if (categories) {
    <div class="column">
      <label>{{ "subcategories" | transloco }}</label>
      <select
        #multiSelectDropdown
        id="test"
        class="ui fluid normal multi-select dropdown"
        multiple=""
        name="subcategoryIds"
      >
        @for (category of categories; track category) { @for (sc of
        category.subcategories; track sc) {
        <option [value]="sc.id">{{ sc.name }}</option>
        } }
      </select>
    </div>
    } @if (commentDocumentMetadatas?.length > 0) {
    <div id="doc-links" class="row">
      <div class="column">
        <label>{{ "document-links" | transloco }}</label>
        <div id="doc-links-container">
          @for (docMetadata of commentDocumentMetadatas; track docMetadata) {
          <a [href]="docMetadata.url" target="_blank" class="ui label">
            {{ docMetadata.filename || docMetadata.url }}
          </a>
          }
        </div>
      </div>
    </div>
    }
    <div class="row">
      <div class="column">
        <app-attachments
          [formControl]="noteControl"
          (input)="handleUrls($event)"
          [disableAttachments]="!useAttachments"
          (setModal)="setNoteModal($event)"
        ></app-attachments>
      </div>
    </div>
    <div class="row actions">
      <div class="column right aligned">
        <span (click)="resetNoteForm()" class="cancel go-back">{{
          "cancel" | transloco
        }}</span>
        <button
          type="submit"
          class="ui primary background button"
          [ngClass]="{
            disabled:
              !note.title ||
              !note.startYear ||
              !note.endYear ||
              !noteControl.value.message
          }"
        >
          {{ "save" | transloco }}
        </button>
      </div>
    </div>
  </form>
</div>
} @if (modalImgSrc) {
<div class="modal-backdrop" (click)="setNoteModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <img [src]="modalImgSrc" />
  </div>
</div>
}
